const alerts = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Alerts",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "Alerts",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              activeLimit: 2,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Another Alert is already active!",
              activeErrorMessage:
                "Please de-active the existing alert message first and try again",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Alert",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Alert Title",
                    placeholder: "Enter Alert Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  color: "Red",
                  further_details: {
                    name: "Expand",
                  },
                  news_item_id: "",
                  news_item_url: "",
                  schedule: false,
                  schedule_input: [],
                },
              },
            },
            children: [
              {
                type: "alertsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select Alert",
                  type: "list",
                  info: true,
                  size: "4",
                  activeLimit: 2,
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                  isGlobal: false,
                  // global: {
                  //   label: "Global Update",
                  //   type: "list",
                  //   info: true,
                  //   size: "4",
                  //   style:
                  //     "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  //   class: "p-0 pt-3 pr-3",
                  //   load_url: "/api/categories/$currentCategoryId/pages",
                  //   draggable: true,
                  //   children: [],
                  // },
                },
                form: {
                  type: "form",
                  size: "8",
                  style: "",
                  class: "pl-4 pt-3",
                  variant: "patch",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    color: {
                      type: "alertinput",
                      label: "Colour",
                      placeholder: "Enter Alert Title",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "10",
                      style: "",
                      options: ["Red", "Amber", "Green"],
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    title: {
                      type: "text",
                      label: "Alert Title",
                      placeholder: "Enter Alert Title",
                      required: true,
                      info: true,
                      character_count: 40,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: true,
                      character_count: 500,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      editorConfig: {
                        toolbar: ["link", "undo", "redo"],
                        heading: {
                          options: [
                            {
                              model: "paragraph",
                              title: "Paragraph",
                              class: "ck-heading_paragraph",
                            },
                            {
                              model: "heading1",
                              view: "h1",
                              title: "Heading 1",
                              class: "ck-heading_heading1",
                            },
                            {
                              model: "heading2",
                              view: "h2",
                              title: "Heading 2",
                              class: "ck-heading_heading2",
                            },
                            {
                              model: "heading3",
                              view: "h3",
                              title: "Heading 3",
                              class: "ck-heading_heading3",
                            },
                            {
                              model: "heading4",
                              view: "h4",
                              title: "Heading 4",
                              class: "ck-heading_heading4",
                            },
                          ],
                        },
                        table: {
                          contentToolbar: [
                            "tableColumn",
                            "tableRow",
                            "mergeTableCells",
                          ],
                        },
                        fontColor: {
                          colors: [
                            {
                              color: "#005EB8",
                              label: "Blue",
                            },
                            {
                              color: "#FF2E2E",
                              label: "Red",
                            },
                            {
                              color: "#4F535B",
                              label: "Main Grey",
                            },
                          ],
                        },
                        link: {
                          decorators: {
                            toggleDownloadable: {
                              mode: "manual",
                              label: "Downloadable",
                              attributes: {
                                download: "file",
                              },
                            },
                            openInNewTab: {
                              mode: "manual",
                              label: "Open in a new tab",
                              attributes: {
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                          },
                        },
                      },
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    further_details: {
                      type: "selectObject",
                      label: "Behaviour",
                      placeholder: "Behaviour",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: [
                        {
                          name: "Expand",
                        },
                        {
                          name: "News Item",
                        },
                        {
                          name: "External Link",
                        },
                      ],
                    },
                    news_item_id: {
                      type: "newsSelect",
                      label: "Select News Item",
                      placeholder: "Select News Item",
                      displayOn: "further_details",
                      displayOnValue: '{"name":"News Item"}',
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    news_item_url: {
                      type: "externalText",
                      label: "Enter Link Here",
                      placeholder: "Enter / Paste Link",
                      displayOn: "further_details",
                      displayOnValue: '{"name":"External Link"}',
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    schedule: {
                      type: "toggle",
                      label: "Schedule",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    schedule_input: {
                      type: "schedulerinput",
                      label: "",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      displayOn: "schedule",
                      displayOnValue: "true",
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                      displayOn: "schedule",
                      displayOnValue: "true",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { alerts };
